import { findVerse, type VerseEnv } from '@rb/shared/admin-verses';
import { useAdminAuth } from '@/auth/use-admin-auth';
import { useActiveVerseStore } from '@/verse/active-verse.store';
import { isVerseOwnedBy, verseOwnerAddress } from '@/shop/vxshop-mapping';

export interface VerseOwnership {
  account: string | null;
  activeVerseId: string | null;
  /** 등록 verse 면 env, 미등록(custom) 이면 null. */
  registeredEnv: VerseEnv | null;
  ownerAddress: string;
  owned: boolean;
}

export function useVerseOwnership(): VerseOwnership {
  const { account } = useAdminAuth();
  const activeVerseId = useActiveVerseStore((s) => s.activeVerseId);
  const registered = activeVerseId ? findVerse(activeVerseId) : undefined;
  return {
    account,
    activeVerseId,
    registeredEnv: registered?.env ?? null,
    ownerAddress: activeVerseId ? verseOwnerAddress(activeVerseId) : '',
    owned: !!activeVerseId && isVerseOwnedBy(activeVerseId, account),
  };
}
